<!-- <ng-template #confirmationModal let-c="close" let-d="dismiss"> -->
<div class="modal-header">
  <h5 class="" id="modal-title">
    {{ modalTitle }}
  </h5>
  <button type="button" *ngIf="showCloseBtn" class="close" aria-describedby="modal-title"
    (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
  <button type="button" *ngIf="showDismissBtn" class="close" aria-describedby="modal-title"
    (click)="activeModal.dismiss(undefined)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="popup-body-font" style="display: table;">
    <i *ngIf="iconClass" class="fa {{iconClass}}" aria-hidden="true"
      style="font-size:20px;padding-right:5px;display: table-cell;vertical-align: top;"></i>
    <div style="display: table-cell;word-break: break-word;line-height: 1.5;" [innerHtml]="modalBody"></div>
  </div>
  <div class="popup-body-font mt-4" style="display: table;" *ngIf="isAdditionalButton">
    <span style="display: table-cell;word-break: break-word;line-height: 1.5;">Start your 14-day free trial today and unlock premium features at no cost.</span>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn {{additionalButtonClass}} mr-auto" (click)="activeModal.close({additional:true})"
    style="border: 1px solid black;" [hidden]="!isAdditionalButton">
    {{additionalButtonName}}
  </button>
  <button type="button" class="btn {{cancelButtonClass}}" (click)="activeModal.dismiss(false)" [hidden]="isAlertOnly">
    {{cancelButtonName}}
  </button>
  <button type="button" class="btn {{ acceptButtonClass }}" (click)="activeModal.close(true)">
    {{acceptButtonName}}
  </button>
</div>
<!-- </ng-template> -->